// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__209EA","left":"styles_left__R7XL5"};